// extracted by mini-css-extract-plugin
export var content = "project-preview-module--content--4ae6e";
export var excerpt = "project-preview-module--excerpt--14898";
export var item = "project-preview-module--item--1ccc0";
export var leadMediaThumb = "project-preview-module--leadMediaThumb--0d073";
export var publishedAt = "project-preview-module--publishedAt--64ff0 typography-module--small--2877f";
export var readmore = "project-preview-module--readmore--141fa typography-module--small--2877f";
export var root = "project-preview-module--root--fbaaa";
export var title = "project-preview-module--title--0929c typography-module--paragraphSans--0fb30";